// Root Saga combined with all Modules's Saga.

import {all} from 'redux-saga/effects';
import {watchTaxDocumentSaga} from './taxDocument/saga'

export default function* rootSaga() {
  yield all([
    // Add watch saga functions here.
    watchTaxDocumentSaga(),
  ]);
}
